// extracted by mini-css-extract-plugin
module.exports = {"not-found":"_3sC_Duhd","center":"_2N4QwmKC","wrapper":"_3kF38HtU","content":"_3rHk8XGX","title":"_3uRO9Fga","subtitle":"_3Wqd8oWq","logo-wrapper":"_1AXRj2XG","logo":"_2W6Zd2bJ"};